import { render, staticRenderFns } from "./apply-detail.vue?vue&type=template&id=6b0e2e9c&scoped=true"
import script from "./apply-detail.vue?vue&type=script&lang=js"
export * from "./apply-detail.vue?vue&type=script&lang=js"
import style0 from "./apply-detail.vue?vue&type=style&index=0&id=6b0e2e9c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0e2e9c",
  null
  
)

export default component.exports